import { useQuery } from "@tanstack/react-query";
import { useAppSelector } from "Hooks/useRedux";
import axios from "axios";

const GisApi = axios.create({
  baseURL: "https://gis.demo.kashantejarat.ir",
});

interface UseStreetsParams {
  bbox?: string;
  zoneId?: string | number;
  fclass?: string;
  name?: string;
  limit?: number;
}

export default function useStreets(params: UseStreetsParams) {
  const { visible } = useAppSelector((state) => state.streets);

  const { data, isLoading, refetch, isFetching, dataUpdatedAt } = useQuery({
    queryKey: ["STREETS", visible, params.bbox, params.zoneId, params.fclass, params.limit, params.name],

    queryFn: async () => {
      let endpoint = `/api/v1/streets?limit=${params.limit || 200}`;

      if (params.name) {
        endpoint = `/api/v1/streets?name=${params.name}&limit=${params.limit || 100}`;
      } else if (params.zoneId) {
        endpoint = `/api/v1/zones/${params.zoneId}/streets?limit=${params.limit || 200}`;
      } else if (params.bbox) {
        endpoint += `&bbox=${params.bbox}`;
        if (params.fclass) endpoint += `&fclass=${params.fclass}`;
      }

      const response = await GisApi.get(endpoint);
      return response.data;
    },
    enabled: visible && (!!params.bbox || !!params.zoneId || !!params.name),
    keepPreviousData: true,
  });

  return { data, isLoading, refetch, isFetching, dataUpdatedAt };
}
